import React, { Fragment, memo, useEffect } from 'react'
import tw from 'twin.macro'
import { useSelector } from 'react-redux'
import { Outlet } from 'react-router-dom'
import { SideNav } from 'src/components/layout/SideNav'
import { SideNavGroup } from 'src/components/layout/SideNavGroup'
import { SideNavItem } from 'src/components/layout/SideNavItem'
import { GSIcon } from 'src/components/shared/GSIcon'
import { AdminFetchRemoteConfigs } from 'src/constants/actionTypes'
import { useAsyncDispatchWithErrorToast } from 'src/hooks/useAsyncDispatchWithErrorToast'
import { useAuthSession } from 'src/hooks/useAuthSession'
import { getRemoteConfigs } from 'src/selectors/remoteConfig'
import { countRemoteConfigsByApp } from 'src/utils/remoteConfig/filterRemoteConfigs'
import { REMOTE_CONFIG_ITEMS } from './remoteConfigNav'

/** Remote Config — its own app with a rail of the two apps that read keys. */
const RemoteConfigLayoutComponent = () => {
  const { asyncDispatchWithErrorToast } = useAsyncDispatchWithErrorToast()
  const { isAuthenticated } = useAuthSession()
  const remoteConfigs = useSelector(getRemoteConfigs)

  // Loaded here rather than by the page: the rail's counts need both apps' keys.
  useEffect(() => {
    if (!isAuthenticated) {
      return
    }

    asyncDispatchWithErrorToast(AdminFetchRemoteConfigs.request())
  }, [asyncDispatchWithErrorToast, isAuthenticated])

  return (
    <Fragment>
      <SideNav>
        <SideNavGroup label="Apps">
          {REMOTE_CONFIG_ITEMS.map((item) => {
            return (
              <SideNavItem
                key={item.to}
                to={item.to}
                label={item.label}
                badge={String(countRemoteConfigsByApp(remoteConfigs, item.app))}
                icon={<GSIcon iconName={item.iconName} size={20} />}
                dataTestId={`remote-config-nav-${item.app}`}
              />
            )
          })}
        </SideNavGroup>
      </SideNav>
      <div css={tw`flex min-w-0 flex-1 flex-col`}>
        <Outlet />
      </div>
    </Fragment>
  )
}

export const RemoteConfigLayout = memo(RemoteConfigLayoutComponent)
